import oddsApi from 'api/oddsApi';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import EmptyTableIcon from 'assets/icons/EmptyTableIcon';
import axios, { CancelTokenSource } from 'axios';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import Typo from 'consts/typography';
import { BetResponseModel } from 'models';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { platformStates } from 'redux/platformSlice';
import MyBetCombo from '../BetForm/MyBetCombo';
import MyBetSingle from '../BetForm/MyBetSingle';
import MyBetTeaser from '../BetForm/MyBetTeaser';
import MybetSingleItem from '../BetForm/MybetSingleItem';
import MyBetComboItem from '../BetForm/MyBetComboItem';
import MyBetTeaserItem from '../BetForm/MyBetTeaserItem';
interface ListBetProps {
  type: 'win' | 'lose' | null;
  onClose: () => void;
  pnlType: 'ATR' | 'TODAY';
}

const ListBet = ({ type, onClose, pnlType }: ListBetProps) => {
  const t = useAppTranslation();
  const [bets, setBets] = React.useState<BetResponseModel[] | null>();
  const platform = useAppSelector(platformStates);

  const [cancelTokenSource, setCancelTokenSource] = useState<CancelTokenSource | null>(null);

  const getBets = async () => {
    const source = axios.CancelToken.source();
    setCancelTokenSource(source);
    const { ok, body } = await oddsApi.getBets(
      {
        page: 0,
        size: 999,
        sort: 'createdDate,desc',
        'calculatedAt.greaterThanOrEqual':
          pnlType === 'TODAY' ? moment(new Date()).startOf('day').toISOString() : null,
        'calculatedAt.lessThanOrEqual':
          pnlType === 'TODAY' ? moment(new Date()).endOf('day').toISOString() : null,
        'status.equals': type === 'win' ? 'WIN' : 'LOSE',
      },
      source.token,
    );
    if (ok && body) {
      setBets(body);
    }
  };

  useEffect(() => {
    setBets(null);
    if (cancelTokenSource) {
      cancelTokenSource.cancel('Request canceled due to new tab');
    }
    if (!!type) {
      getBets();
    }
    return () => {
      setBets(undefined);
    };
  }, [type]);
  return (
    <div
      className={`overlay-bet-form z-500 primary-text-color ${
        !!type ? 'overlay-bet-form__show' : 'overlay-bet-form__hide'
      } ${
        platform.isLaptop || platform.isDesktop || platform.isLargeDesktop
          ? 'overlay-bet-form__large'
          : ''
      }`}
    >
      {!!type && (
        <div className="bet-form">
          <div className="bet-form-header">
            <h3 className={`primary-text-color ${Typo.h3}`}>
              {type === 'win' ? t('betFormMainTab.winningBets') : t('betFormMainTab.losingBets')}
            </h3>
            <button onClick={onClose}>
              <AiOutlineCloseCircle className="w-6 h-6 font-bold primary-text-color" />
            </button>
          </div>
          <div className="my-bets-form">
            <div className="my-bets-list">
              {bets ? (
                <>
                  {bets.length !== 0 ? (
                    <>
                      {bets.map((bet) =>
                        bet.type === 'SINGLE' ? (
                          // <MyBetSingle tab={2} key={`my-bet-single-${bet.id}`} bet={bet} />
                          <MybetSingleItem tab={2} key={`my-bet-single-${bet.id}`} bet={bet} />
                        ) : bet.type === 'TEASER' ? (
                          <MyBetTeaserItem tab={2} key={`my-bet-combo-${bet.id}`} bet={bet} />
                        ) : (
                          // <MyBetCombo tab={2} key={`my-bet-combo-${bet.id}`} bet={bet} />
                          <MyBetComboItem tab={2} key={`my-bet-combo-${bet.id}`} bet={bet} />
                        ),
                      )}
                    </>
                  ) : (
                    <div className="my-bets-empty">
                      <EmptyTableIcon />
                    </div>
                  )}
                </>
              ) : (
                <div className="my-bets-list__spinner">
                  <LoadingSpinner />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListBet;
